import React from "react";
import { FormInput } from "../FormInput";

import {
    requiredRule,
    noSpace,
    minLengthRule,
    maxLengthRule,
    emailValidRule,
    passwordValidRule,
    validUsernameRule,
} from "./inputValidation";

/**
 * creates and returns object representation of form field
 *
 * @param {string} name - input name
 * @param {string} type - input type
 * @param {string} defaultValue - default value for the input
 */
function createFormFieldConfig(className, name, type, placeholder, defaultValue = "",) {
    return {
        renderInput: (handleChange, value, isValid, error, key) => {
            return (
                <FormInput
                    className={className}
                    key={ key }
                    name={ name }
                    type={ type }
                    value={ value }
                    isValid={ isValid }
                    handleChange={ handleChange }
                    errorMessage={ error }
                    placeholder={placeholder}
                />
            );
        },
        value: defaultValue,
        valid: false,
        errorMessage: "",
        touched: false
    };
}

// object representation of signup form
export const signupForm = {
    name: {
        ...createFormFieldConfig("username", "name", "text", "username", ""),
        validationRules: [
            requiredRule("username"),
            noSpace("username"),
            validUsernameRule("username"),
            minLengthRule("username", 3),
            maxLengthRule("username", 25)
        ]
    },
    email: {
        ...createFormFieldConfig("email-id", "email", "email", "email",  ""),
        validationRules: [
            requiredRule("email"),
            emailValidRule("email"),
            minLengthRule("email", 10),
            maxLengthRule("email", 64)
        ]
    },
    password: {
        ...createFormFieldConfig("password", "password", "password", "password", ""),
        validationRules: [
            requiredRule("password"),
            passwordValidRule("password"),
            minLengthRule("password", 8),
            maxLengthRule("password", 20)
        ]
    }
};
